import min from 'date-fns/min';
import max from 'date-fns/max';

export function createElement(element) {
	return document.createElement(element);
}

export function chunk(arr, len) {
	let chunks = [];
	let i = 0;
	let n = arr.length;

	while (i < n) {
		chunks.push(arr.slice(i, i += len));
	}

	return chunks;
}

export function numberClamp(num, min, max) {
	return Math.min(Math.max(num, min), max);
}

export function dateClamp(date, minDate, maxDate) {
	return min([max([date, minDate]), maxDate]);
}

export function first(array) {
	return (array && array.length) ? array[0] : undefined;
}

export function last(array) {
	let length = array == null ? 0 : array.length;
	return length ? array[length - 1] : undefined;
}

export function ensureArray(value) {
	if (Array.isArray(value)) {
		return value;
	} else {
		return [ value ];
	}
}
